var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.03899 6.41659C4.73814 5.92468 4.58337 5.3192 4.58337 4.58325C4.58337 3.13225 5.67453 1.83325 7.33337 1.83325C8.99437 1.83325 10.3339 2.94574 11 4.68759C11.6662 2.94574 13.0057 1.83325 14.6667 1.83325C16.3256 1.83325 17.4167 3.13225 17.4167 4.58325C17.4167 5.3192 17.2619 5.92468 16.9611 6.41659H18.3334C19.3459 6.41659 20.1667 7.2374 20.1667 8.24992V10.0833C20.1667 11.0958 19.3459 11.9166 18.3334 11.9166V18.3333C18.3334 19.3458 17.5126 20.1666 16.5 20.1666H5.50004C4.48752 20.1666 3.66671 19.3458 3.66671 18.3333V11.9166C2.65419 11.9166 1.83337 11.0958 1.83337 10.0833V8.24992C1.83337 7.2374 2.65419 6.41659 3.66671 6.41659H5.03899ZM10.0834 8.24992H3.66671V10.0833H10.0834V8.24992ZM18.3334 10.0833H11.9167V8.24992H18.3334V10.0833ZM10.0834 18.3333V11.9166H5.50004V18.3333H10.0834ZM16.5 18.3333H11.9167V11.9166H16.5V18.3333ZM7.33337 3.66659C6.76472 3.66659 6.41671 4.08088 6.41671 4.58325C6.41671 5.73205 7.34896 6.27828 9.56034 6.3932C9.31457 4.68555 8.3987 3.66659 7.33337 3.66659ZM12.375 6.3932C12.6208 4.68555 13.5367 3.66659 14.602 3.66659C15.1707 3.66659 15.5187 4.08088 15.5187 4.58325C15.5187 5.73205 14.5864 6.27828 12.375 6.3932Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.c79222e2964265e47ef52fcec19ecf0e.svg";
export { ForwardRef as ReactComponent };